<template>
	<modal @close="close">
		<div class="subscribe">
			<a class="close" @click="close">X</a>
			<iframe
				src="https://docs.google.com/forms/d/e/1FAIpQLScM7R8GSCPJeuznhCCSAJ0BOqN73VrpcjFJTRtvKwOtkSvs6Q/viewform?embedded=true"
				width="100%"
				height="100%"
				frameborder="0"
				marginheight="0"
				marginwidth="0"
			></iframe>
		</div>
	</modal>
</template>

<script>
import modal from "./modal.vue";

export default {
	components: {modal},
	methods: {
		close() {
			this.$store.state.subscribe = false;
		},
		key(e) {
			if (e.key === "Escape") this.close();
		}
	},
	created() {
		window.addEventListener("keydown", this.key);
	},
	beforeDestroy() {
		window.removeEventListener("keydown", this.key);
	}
};
</script>

<style lang="scss" scoped>
.subscribe {
	position: relative;
	width: 35em;
	max-width: 95%;
	height: 40em;
	max-height: 95%;
	box-shadow: 0 0px 8px lighten($black1, 20%);
	background-color: $greylight1;

	.close {
		position: absolute;
		top: 0;
		left: 0;
		background-color: $color1;
		border: 1px solid $greylight3;
		font-weight: 600;
		border-top: 0;
		border-right: 0;
		$s: 2.2em;
		width: $s;
		height: $s;
		display: flex;
		justify-content: center;
		align-items: center;
		user-select: none;
		font-size: 0.7em;
	}
}
</style>
